const listingHighlightsTabListing = {
  displayField: 'header',
  name: 'Listing Highlights Tab Listing',
  description: 'Single Listing for Tabs',
  fields: [
    {
      id: 'header',
      name: 'Header Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'rating',
      name: 'Rating',
      type: 'Number',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'students',
      name: 'Students',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'distance',
      name: 'Distance',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'reviewAvg',
      name: 'Average Review Score',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'reviewNum',
      name: 'Number of Reviews',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'listingHighlightsTabListing',
    version: 30,
    updatedAt: '2023-03-06T20:44:26.024Z'
  }
};
export default listingHighlightsTabListing;